import script from "./AdminReportingPagePage.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminReportingPagePage.vue?vue&type=script&setup=true&lang=js"

import "./AdminReportingPagePage.vue?vue&type=style&index=0&id=7b800d22&lang=css"

const __exports__ = script;

export default __exports__